﻿window.refreshChannelFilter = function () {
    var triggerDiv = document.getElementById('tifilter_refresh-channel-filter-trigger');
    if (triggerDiv) {
        var btn = triggerDiv.querySelector('button');
        if (btn) {
            btn.click(); // эмулирует нажатие → вызовет PostEvent к RefreshChannelFilter
        }
    }
};

window.fillCodes = function (args) {
    const listContainerId = args.targetId;
    const codes = args.codes;
    if (codes.length > 0) {
        let container = $('#' + listContainerId);
        container.empty();
        container.append('<div class="clear"><a href="#">Очистить</a></div>');
        for (let code of codes) {
            container.append("<div>" + code + "</div>");
        }
    }
}

window.collectSelectedItems = function (checkBoxSelector, dataName, targetId) {
    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }

    let codes = $(checkBoxSelector + ":checked").map((i, chck) => {
        return $(chck).data(dataName).toString();
    }).get();

    var cached = $(checkBoxSelector + ".cached").val();
    if (cached) {
        codes.push(...cached.split(','));
        codes = codes.filter(onlyUnique);
    }

    var joinedCodes = codes.join();

    var target = $('#' + targetId);

    var listContainerId = target.data('list-container');
    var dependenceId = target.data('clear-dependence');

    var isNeedClear = dependenceId && target.val() != joinedCodes;

    $('#' + targetId).val(joinedCodes).trigger('change');

    if (listContainerId) {
        let container = $('#' + listContainerId);
        container.empty();
        if (codes.length > 0) {
            container.append('<div class="clear"><a href="#">Очистить</a></div>');
            for (let code of codes) {
                container.append("<div>" + code + "</div>");
            }
        }
    }

    if (isNeedClear) {
        var depListId = $('#' + dependenceId).val("").data('list-container');
        if (depListId) {
            $('#' + depListId).empty();
        }
    }
}

window.toggleCachedItem = function (cacheSelector, codeValue, el) {
    if ($(el).attr("type") == "checkbox") {
        var cached = $(cacheSelector).val();
        var cachedCodes = (cached ?? []).split(',').filter(v => v);
        if ($(el).prop("checked")) {
            cachedCodes.push(codeValue);
        } else {
            cachedCodes = cachedCodes.filter(v => v != codeValue);
        }

        $(cacheSelector).val(cachedCodes.join());
    }
}

window.switchToParent = function (el) {
    var parentId = $(el).closest(".modal-dialog").data("c-parent");
    if (parentId) {
        $("#" + parentId).css("z-index", 101);
    }
}

window.checkForNumberInput = function (evt) {
    let code = (evt.which) ? evt.which : evt.keyCode;
    return (48 <= code && code <= 57);
}

window.updateSaveSettingsJson = function () {
    var checkbox = document.querySelector('[data-role="save-settings-checkbox"]');
    if (!checkbox) return;
    
    var okButton = document.querySelector('button[data-e="oncreaterelations"]');
    if (!okButton) return;
    
    var isChecked = checkbox.checked;
    
    okButton.setAttribute('data-p-saveusersettingsoption', isChecked ? 'True' : 'False');
};

window.windowVariables = function () {
    var instance = {
        set: function (args) {
            window[args.name] = args.value;
        },
        setAllTiList: function (list) {
            window['allTi'] = list;
        },
        setAllRelationsList: function (list) {
            window['allRelations'] = list;
        },
        get: function (name) {
            return window[name];
        }
    }
    return instance;
}();

window.clearAISAndArea = function () {
    $('#tifilter_atsselectedarea').val('').trigger('change');
    $('#tifilter_atsselectedais').val('').trigger('change');
    
    $('#tifilter_ais_list_container').empty();  
    $('#tifilter_area_list_container').empty();

    return false;
}

window.tiRelations = function () {
    var instance = {
        changeTISelection: function (el, tiListCtrlId, relationsListCtrlId, totalCount) {
            var isChecked = $(el).prop("checked");

            if ($(el).hasClass("select-all")) {
                $('#' + tiListCtrlId).val(isChecked ? window.allTi ?? '' : '');
                $('#' + relationsListCtrlId).val(isChecked ? window.allRelations ?? '' : '');
                $('.checkbox-select-ti').not('.select-all').prop("checked", isChecked);
            }
            else {
                var selectedTiId = $(el).data('ti-id');
                var selectedRelationId = $(el).closest('.ti-cell').find('.relations-new tr.relation-row').map((_, el) =>
                    $(el).data('relation-id')
                ).get();

                var tiIdList = $('#' + tiListCtrlId).val().split(",").filter(v => v);
                var relationsIdList = $('#' + relationsListCtrlId).val().split(",").filter(v => v);
                if (isChecked) {
                    tiIdList.push(selectedTiId);
                    relationsIdList.push(...selectedRelationId);
                } else {
                    tiIdList = tiIdList.filter((v) => v != selectedTiId);
                    relationsIdList = relationsIdList.filter(r => !selectedRelationId.includes(r));
                }
                $('#' + tiListCtrlId).val(tiIdList);
                $('#' + relationsListCtrlId).val(relationsIdList);

                setSelectAllProps(tiIdList.length, totalCount);
            }
        },

        setSelectAllState: function (args) {
            var selectedCount = $('#' + args.targetId).val().split(",").filter(v => v).length;
            setSelectAllProps(selectedCount, args.totalCount);
        }
    };

    var setSelectAllProps = function (selectedCount, totalCount) {
        var $selectAll = $(".select-all");
        if (selectedCount == 0) {
            $selectAll.prop("indeterminate", false).prop("checked", false);
        }
        else if (selectedCount < totalCount) {
            $selectAll.prop("indeterminate", true);
        }
        else {
            $selectAll.prop("indeterminate", false).prop("checked", true);
        }
    }

    return instance;
}();

$(document).ready(function () {
    $(document).on('click', 'div.clear', function (e) {
        e.preventDefault();
        window.clearAISAndArea();
    });
});